import React from 'react'
import { Link } from 'react-router-dom'

const Features = () => {
  return (
    <section className="feature-section-three">
    <div className="auto-container">
      <div className="row">
        {/*Feature Block*/}
        <div className="feature-block-five col-lg-3 col-md-6 col-sm-12 wow fadeInUp">
          <div className="inner-box">
            <div className="icon-box">
              <i className="icon flaticon-certificate-1" />
            </div>
            <h4>Confirm Speakers</h4>
            <p>
              Dolor sit amet consectetur elit sed eiusmod tempor in idunt labore
              cdet dolore magna aliqua.
            </p>
            <Link  to="schedule-detail.html" className="theme-btn btn-style-one">
              <span className="btn-title">
                More Detail <i className="fa fa-angle-double-right" />
              </span>
            </Link> 
          </div>
        </div>
        {/*Feature Block*/}
        <div
          className="feature-block-five col-lg-3 col-md-6 col-sm-12 wow fadeInUp"
          data-wow-delay="300ms"
        >
          <div className="inner-box">
            <div className="icon-box">
              <i className="icon flaticon-idea" />
            </div>
            <h4>Best Digital Ideas</h4>
            <p>
              Dolor sit amet consectetur elit sed eiusmod tempor in idunt labore
              cdet dolore magna aliqua.
            </p>
            <Link  to="schedule-detail.html" className="theme-btn btn-style-one">
              <span className="btn-title">
                More Detail <i className="fa fa-angle-double-right" />
              </span>
            </Link> 
          </div>
        </div>
        {/*Feature Block*/}
        <div
          className="feature-block-five col-lg-3 col-md-6 col-sm-12 wow fadeInUp"
          data-wow-delay="600ms"
        >
          <div className="inner-box">
            <div className="icon-box">
              <i className="icon flaticon-meeting" />
            </div>
            <h4>Networking People</h4>
            <p>
              Dolor sit amet consectetur elit sed eiusmod tempor in idunt labore
              cdet dolore magna aliqua.
            </p>
            <Link  to="schedule-detail.html" className="theme-btn btn-style-one">
              <span className="btn-title">
                More Detail <i className="fa fa-angle-double-right" />
              </span>
            </Link> 
          </div>
        </div>
        {/*Feature Block*/}
        <div
          className="feature-block-five col-lg-3 col-md-6 col-sm-12 wow fadeInUp"
          data-wow-delay="900ms"
        >
          <div className="inner-box">
            <div className="icon-box">
              <i className="icon flaticon-inspiration" />
            </div>
            <h4>Inspiring Keynotes</h4>
            <p>
              Dolor sit amet consectetur elit sed eiusmod tempor in idunt labore
              cdet dolore magna aliqua.
            </p>
            <Link  to="schedule-detail.html" className="theme-btn btn-style-one">
              <span className="btn-title">
                More Detail <i className="fa fa-angle-double-right" />
              </span>
            </Link> 
          </div>
        </div>
      </div>
    </div>
  </section>
  
  )
}

export default Features